import { render, staticRenderFns } from "./CaiwuSaiquList.vue?vue&type=template&id=71f82387&scoped=true&"
import script from "./CaiwuSaiquList.vue?vue&type=script&lang=js&"
export * from "./CaiwuSaiquList.vue?vue&type=script&lang=js&"
import style0 from "./CaiwuSaiquList.vue?vue&type=style&index=0&id=71f82387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f82387",
  null
  
)

export default component.exports